// extracted by mini-css-extract-plugin
module.exports = {"main":"RoundedCheckbox_main__BjlRy"};